import { StoreState } from "store";

export const getFetchStatus = (state: StoreState) => state.searchAiSummary.fetchStatus;
export const getSearchAiSummaryText = (state: StoreState) => state.searchAiSummary.searchAiSummary?.text;
